export const getMinMaxLabel = (min: number, max: number): string => {
	if (min > max) {
		return "";
	}

	var text = "";

	if (min > 0) {
		text += min;
	}
	if (min == 0 && max > 0) {
		text += min + " - " + max;
	}
	if (min > 0 && max > 0 && min !== max) {
		text += " - " + max;
	}

	return text;
};
